<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{ 'section-loading': infoLoading }"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75 pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              v-if="categoryInfo.upload_file"
              class="text-orange"
              style="text-decoration:none;"
              @click="download()"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2"></i>
            </a>
          </h4>
          <div class="mb-line" style>
            <span class="font-weight-bold mr-2">
              {{ categoryInfo.upload_date | dateFormat }} ~
              {{ categoryInfo.end_date | dateFormat }}
            </span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">
              {{
              categoryInfo.description
              }}
            </span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{ 'section-loading': isLoading_btn }">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
              type="button"
              style="height:43px;"
              @click="backToIndex"
              class="position-absolute btn btn-default m-0"
              v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{ 'section-loading': isLoading }">
      <div class="row">
        <event-detection-data-table
          :height="data_table_height"
          @update="updateSelection"
          @changeLoading="changeIsLoadingStatus"
          @scheduled-access="ScheduledAccess"
          @openInfoModal="openCathayCustInfoModal"
          :table-data="tableData"
          :isROCFormat="false"
          :categoryInfo="categoryInfo"
          ref="data_table_ref"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8"></div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            type="button"
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="openPrintModal"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal
      :open="printModalOpen"
      :custs="selectionWithPrint"
      @close="panelClose('printModalOpen')"
    />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <!-- 滿意度調查 -->
    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <!-- 排訪 -->
    <scheduled-access
      :open="ScheduledAccessModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('ScheduledAccessModalOpen')"
      @submit="submitScheduledAccess"
    />

    <!-- 泰好客說明視窗 -->
    <cathay-cust-info-modal
      :open="cathayCustInfoModalOpen"
      @close="panelClose('cathayCustInfoModalOpen')"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import EventDetectionDataTable from "@/desktop/components/ListsArea/DataTable/EventDetectionDataTable";
import SatisfactionModal from "@/desktop/components/ListsArea/SatisfactionModal";
import ScheduledAccess from "@/desktop/components/ListsArea/ScheduledAccess";
import CathayCustInfoModal from "@/desktop/components/CathayCustInfoModal"
//service
import {
  queryEventDetection,
  getCategoryDetail,
  isSatisfactionSurveyFinish,
  queryBookedVisitEvent,
  downloadFile_m0,
} from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "EventDetection",
  mixins: [commonMixin],
  components: {
    EventDetectionDataTable,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess,
    CathayCustInfoModal,
  },
  props: {
    status: String
  },
  data() {
    //data block layout
    return {
      currentPage: 0,
      isLoading: false,
      isLoading_btn: false,
      isBtnEnble: true,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      selectionWithPrint: [], //列印用資料集
      visitList: [],
      satisfactionModalOpen: false,
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      cathayCustInfoModalOpen: false,
      categoryInfo: {},
      currentRecord: {},
      edit_access_index: 0,
      edit_access_name: "",
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_PRECISION_MARKETING_LIST");
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.isBtnEnble = result.body.isfinish === "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    init() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      // 取得列表資料
      this.isLoading = true;
      // let serNoList = [];
      // serNoList.push(this.$store.state.listAreaSerNo);
      queryEventDetection(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.isLoading = false;
        if (result.header && result.header.status === "200") {
          let connect = "";
          let CsidData = "";
          result.body.detail.map(item => {
            connect = connect + "," + item.csidno;
          });
          if (connect.length > 0) {
            CsidData = connect.substr(1);
          }
          queryBookedVisitEvent(this.$store.state.userInfo.id, CsidData).then(
            visitData => {
              this.isLoading = false;
              if (visitData.header && visitData.header.status === "200") {
                this.visitList = visitData.body.detail;
                this.tableData = result.body.detail.map(item => {
                  let visit = { visit: {} };
                  this.visitList.forEach(vItem => {
                    if (vItem.csidno == item.csidno) {
                      visit.visit = vItem;
                    }
                  });
                  let ageText = this.paddingLeft(
                    item.age == "0" ? "0" : item.age ? item.age : "00000",
                    4,
                    "0"
                  );
                  let birthdayText = item.csbrdy || "0000-01-01";
                  return {
                    name: item.csname || "",
                    index: item.csidno || "",
                    id: item.csidno || "",
                    vip_level: item.vip || "",
                    sex: Number(item.csidno[1]),
                    mobile: item.csmtel || "",
                    birthday: item.csbrdy || "",
                    age: item.age == undefined ? "" : item.age.toString(), //客戶年齡
                    birthdaySort: ageText + "_" + birthdayText, //生日排序用
                    address:
                      (item.home_addr_zip || "") +
                      (item.home_addr1 || "") +
                      (item.home_addr2 || "") +
                      (item.home_addr3 || ""), //地址
                    visit_pri: item.visit_pri || "N", //優先拜訪 (Y:是 N:否)
                    policy_no: item.policy_no || "", //保單號碼
                    upd_date: item.upd_date || "", //回報日(無法拜訪客戶回報)
                    visit_serno: item.visit_serno || "", //回報序號
                    record: item.previous_date || "",
                    event_name: item.event_cd || "", //重要事件
                    relationship: item.record_agcsrt || "",
                    is_exist: item.is_exist || false, //判斷是否有客戶資料
                    visit_time: item.visit_time,
                    hos_mkt_level: item.hos_mkt_level || '', //泰好客資訊(住)
                    sur_mkt_level: item.sur_mkt_level || '', //泰好客資訊(手)
                    rei_mkt_level: item.rei_mkt_level || '', //泰好客資訊(實)
                    acc_mkt_level: item.acc_mkt_level || '', //泰好客資訊(意)
                    dd_mkt_level: item.dd_mkt_level || '', //泰好客資訊(重)
                    ltc_mkt_level: item.ltc_mkt_level || '', //泰好客資訊(長)
                    life_mkt_level: item.life_mkt_level || '', //泰好客資訊(壽)
                    sav_mkt_level: item.sav_mkt_level || '', //泰好客資訊(儲)
                    inv_mkt_level: item.inv_mkt_level || '', //泰好客資訊(投)
                    mkt_score : this.getMktScore(item),
                    recordInfo: {},
                    ...visit // 寫入排訪資料
                  };
                });
              }
            }
          );
          this.registerHanlink(); // for hard word
        }
      });

      // 取得專區資訊
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status === "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    ScheduledAccess(record) {
      this.currentRecord = record;
      this.panelOpen("ScheduledAccessModalOpen");
    },
    submitScheduledAccess() {
      this.panelClose("ScheduledAccessModalOpen");
      // 資料初始化
      this.init();
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          this.categoryInfo.upload_file
        ).then(result => {
          if (result.type === "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, this.categoryInfo.upload_file);
          }
        });
      }
    },
    //開啟列印視窗
    openPrintModal() {
      this.selectionWithPrint = [];
      let sortedList = this.$refs.data_table_ref.getSortedList(); //取得排序資料集
      sortedList.forEach(item => {
        if (this.selection.includes(item.id)) {
          this.selectionWithPrint.push(item.id); //列印資料依照當前順序呈現
        }
      });
      this.panelOpen("printModalOpen");
    },
    //開啟泰好客說明視窗
    openCathayCustInfoModal () {
      this.panelOpen('cathayCustInfoModalOpen');
    },
    //計算泰好客加權分數
    getMktScore(data) {
      let mktType = ["hos_mkt_level", "sur_mkt_level", "rei_mkt_level",
       "acc_mkt_level", "dd_mkt_level", "ltc_mkt_level", "life_mkt_level", "sav_mkt_level", "inv_mkt_level"];
      let returnScore = 0;

      //類型為1(分數2)，類型為2 or 3 (分數1)，其餘分數0
      mktType.forEach(value => {
        if (data[value] == "1") {
          returnScore += 2;
        } else if(data[value] == "2" || data[value] == "3") {
          returnScore += 1;
        }
      });

      return returnScore;
    },
    //切換遮罩
    changeIsLoadingStatus(flag) {
      this.isLoading = flag;
    }
  },
  mounted() {
    // 資料初始化
    this.init();
    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("orientationchange", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>